import React from 'react';
import './style.css';
import Images from "../../Images";
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import { FaTiktok } from 'react-icons/fa';
import PrivacyPolicy from '../../assets/Legal/PrivacyPolicy.pdf'
import TermsofService from '../../assets/Legal/TermsofService.pdf'
import RefundAndCancellationPolicy from '../../assets/Legal/RefundAndCancellationPolicy.pdf'
import { useLocation } from "react-router-dom";

const Footer = (props) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname.includes('nursing') || location.pathname.includes('flight-attendant');
  const isMockPage = location.pathname === '/mockInterviewer';
  const isStarterPack = location.pathname === '/starter-pack';
  const isComparison = location.pathname.includes('alternative');
  const isReferralPage = location.pathname.includes('referral');
  
  return (
    <footer className={`homepage_footer ${(isHomePage || isMockPage || isReferralPage || isStarterPack || isComparison) ? 'other' : 'home'}`}>
      <div className="footer-line"></div>
      <div className="footer-content">
        <div className="footer-logo-container">
          <img
            src={Images.NORA_LOGO}
            alt="Nora AI"
            className="footer_logo"
          />
        </div>
        <div className="footer-content-columns-contain">
          <div className="footer-content-columns">
          </div>
          <div className="footer-content-columns">
            <h3>Prep by Roles</h3>
            <p> <a href="/nursing"> Registered Nurse</a></p>
            <p> <a href="https://interview.norahq.com/login"> Product Management</a></p>
            <p> <a href="/flight-attendant"> Flight Attendant</a></p>
            <p> <a href="https://interview.norahq.com/login"> Retail</a></p>
            <p> <a href="https://interview.norahq.com/login"> Software Engineering</a></p>
          </div>

          <div className="footer-content-columns">
            <h3>For Mock Interview</h3>
            <p> <a href="https://interview.norahq.com/login">Login</a></p>
            <p> <a href="mailto:hannan@norahq.com">Contact</a></p>
            <p><a href="https://interview.norahq.com/interview-guides" target="_blank" rel="noopener noreferrer">Interview Guide</a></p>
          </div>

          <div className="footer-content-columns">
            <h3>Compare Us</h3>
            <p> <a href="https://interview.norahq.com/interview-coder-alternative">Interview Coder</a></p>
            <p> <a href="https://interview.norahq.com/lockedin-ai-alternative">LockedIn AI</a></p>
            <p> <a href="https://interview.norahq.com/exponent-alternative">Exponent</a></p>
          </div>
          
          <div className="footer-social-icons-small footer-content-columns">
            <a href="https://www.instagram.com/trynorahq/?hl=en" target="_blank" rel="noreferrer">
              <InstagramIcon  className="sc-icons"/>
            </a>
            <a href="https://www.linkedin.com/company/norahq" target="_blank" rel="noreferrer">
              <LinkedInIcon className="sc-icons"/>
            </a>
            <a href="https://www.tiktok.com/@norahq" target="_blank" rel="noreferrer">
              <FaTiktok className="sc-icons"/>
            </a>
          </div>
        </div>

      </div>
      <div className="footer-links">
        <div className="footer-doc">
          <div className="footer-doc-txt">
            <p><strong>Nora AI.</strong></p>
            <p className="right-text">All Rights Reserved</p>
          </div>
          <a href = {PrivacyPolicy} target = "_blank">Privacy Policy</a>
          <a href = {TermsofService} target = "_blank">Terms of Service</a>
          <a href = {RefundAndCancellationPolicy} target = "_blank">Refund Policy</a>
        </div>
        <div className="footer-social-icons">
          <a href="https://www.instagram.com/trynorahq/?hl=en" target="_blank" rel="noreferrer">
            <InstagramIcon  className="sc-icons"/>
          </a>
          <a href="https://www.linkedin.com/company/norahq" target="_blank" rel="noreferrer">
            <LinkedInIcon className="sc-icons"/>
          </a>
          <a href="https://www.tiktok.com/@norahq" target="_blank" rel="noreferrer">
            <FaTiktok className="sc-icons"/>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
